export const saveLocalhostCountry = (): void => {
    if (window.location.hostname === 'localhost') {
        sessionStorage.setItem(
            'country',
            new URLSearchParams(window.location.search).get('country') ?? 'AT',
        );
    }
};
